var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import StockInitService from '../../../api/StockInitService';
import HeaderItem from "../../../components/HeaderItem";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.supplierorganOptions = [];
        _this.supplierdepotOptions = [];
        return _this;
    }
    default_1.prototype.created = function () {
        this.service = StockInitService.getInstance();
        if (this.handleStatus === 1) {
            this.getSupplierorganOptions();
        }
    };
    default_1.prototype.mounted = function () { };
    default_1.prototype.changeStockType = function () {
        if (this.formData.stock_type == 2) {
            this.$emit('emptyOrderDetail');
        }
    };
    default_1.prototype.getSupplierorganOptions = function () {
        var _this = this;
        this.service.getSupplierorganOptions().then(function (res) {
            if (res.data.success) {
                _this.supplierorganOptions = res.data.data;
                if (_this.handleType == 0) {
                    _this.formData.organ_id = res.data.data && res.data.data[0] ? res.data.data[0].organ_id : '';
                }
                _this.getSupplierdepotOptions();
            }
        });
    };
    default_1.prototype.getSupplierdepotOptions = function () {
        var _this = this;
        var params = {
            organ_id: this.formData.organ_id,
            type: 1,
            is_init: 0
        };
        this.service.getSupplierdepotOptions(params).then(function (res) {
            if (res.data.success) {
                _this.supplierdepotOptions = res.data.data;
                if (_this.handleType == 0) {
                    _this.formData.depot_id = res.data.data && res.data.data[0] ? res.data.data[0].depot_id : '';
                }
            }
        });
    };
    default_1.prototype.changeOrganId = function (rec) {
        this.getSupplierdepotOptions();
    };
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "formData", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number
        })
    ], default_1.prototype, "handleStatus", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number
        })
    ], default_1.prototype, "handleType", void 0);
    default_1 = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
